import React from 'react'
import './findagent.scss'
import Select from 'react-select';
import { images } from "../../../utils/customFn";
const FindAgent = (props) => {
    const defaultOptions = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ];
    const Mainoptions = Array.isArray(props.options) ? props.options : defaultOptions;
    return (
        <div className='findagent-wrapper'>
            <h2>Find an agent</h2>
            <div className='industryDropdownSelector'>
                <div className='Zip-code'>
                   <img src={images['Contact-Location.avif']} alt="location" />
                   <input type="text" placeholder="Enter your ZIP code" maxlength="5"/>
                </div>
                <div className='industry-dropdown'>
                    <Select
                        options={Mainoptions}
                        placeholder="Select an industry"
                        className="custom-react-select"
                        classNamePrefix="react-select"
                    />
                </div>
                <button type="submit" class="findAgentButton">Find</button>
            </div>
        </div>
    )
}

export default FindAgent